import { logger as LOG } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

export const logger = LOG.extend('JOIN OR SIGN IN STATE MACHINE');
